<div id="selection-container" 
[style.display]="dm.isSelected('draw','design_modes')? 'none' : 'flex'"
>

<div class="size-row" *ngIf="width !== -1">
    <span>{{width}} x {{height}} </span>
</div>

<div class="selection-row" *ngIf="!hide_actions">


    <div id="selection-actions" class="selection-actions">
        
        
        <!-- <ng-container *ngIf="!hide_actions">
        <button mat-icon-button
        matTooltip="edit design in this region"
        [matMenuTriggerFor]="actions"
        ><i class="fas fa-magic"></i></button>
        </ng-container>

        <mat-menu #actions="matMenu">
        <ng-container *ngFor="let action of design_actions">
        <button class="menu-button" 
        mat-menu-item 
        (click)="designActionChange(action.value)">
        <span class="{{action.icon}}"></span>
        <span>{{action.viewValue}}</span>
        </button>

        </ng-container>
         </mat-menu> -->



        
        <button mat-icon-button  matTooltip="copy this region" (click)="copyEvent()" [color]= "!has_copy ? 'primary' : 'accent'" ><i class="fas fa-clipboard"></i></button>

        <button mat-icon-button color="primary" [disabled]="!has_copy" [color]= "!has_copy ? 'primary' : 'accent'"  matTooltip="paste into this region" (click)="pasteEvent('original')"><i class="fas fa-paste"></i></button>

    </div>
</div>



</div>